export const TRACK = 'TRACK';
export const SET_IN_TRACKLIST = 'SET_IN_TRACKLIST';
export const SET_ACTIVE_TRACK = 'SET_ACTIVE_TRACK';
export const SET_ACTIVE_TRACK_ID = 'SET_ACTIVE_TRACK_ID';
export const RESET_ACTIVE_TRACK = 'RESET_ACTIVE_TRACK';
export const SET_IS_PLAYING = 'SET_IS_PLAYING';
export const SET_SEEK_TIME = 'SET_SEEK_TIME';
export const SET_DURATION = 'SET_DURATION';
export const SET_READY_STATE = 'SET_READY_STATE';
export const SET_PROGRESS = 'SET_PROGRESS';
export const SET_PROGRESS_LOADED = 'SET_PROGRESS_LOADED';
export const SET_PROGRESS_COMPLETED = 'SET_PROGRESS_COMPLETED';
export const SET_SHUFFLE_MODE = 'SET_SHUFFLE_MODE';
export const SET_REPEAT_MODE = 'SET_REPEAT_MODE';
export const SET_IS_OPEN_PLAYLIST = 'SET_IS_OPEN_PLAYLIST';

